/**
 * Main(-JS-File)
 */

import {getRootVar} from '@ifabnpm/bootstrap/utils.js';

import TranslationManager from '@ifabnpm/bootstrap/service/translation-manager.js';

import config from './config';
import l10n from './config/l10n';
import components from './components';
import initial from './initial';
import layout from './layout';
import vendors from './vendors';

// --------
// Let's go
// --------

//
// In `window` das Objekt ´pageInstance´ zusammenstellen (Konfiguratione, Übersetzungen etc.)
//

window.pageInstance = window.pageInstance || {};

// Übersetzungen (l10n)
if (!window.pageInstance.tm) {
	window.pageInstance.tm = new TranslationManager();

	window.pageInstance.tm.addLanguages(l10n);
}

window.pageInstance.prefix = getRootVar('global-rootvar-prefix');
window.pageInstance.config = config;

document.addEventListener('DOMContentLoaded', function () {
	window.RootvarPrefix = getRootVar('global-rootvar-prefix');

	components();
	vendors();
	initial();
	layout().then(r => {
		// Do nothing ...
	});
});
